import { FC } from 'react';
import { Route, Switch } from 'react-router';
import PaymentRecord from '../pages/payment/record';
import PaymentCharge from '../pages/payment/charge';
import PaymentRefund from '../pages/payment/refund';
import PaymentCoupon from '../pages/payment/coupon';
import PaymentCouponList from '../pages/payment/coupon/list';
import PaymentCouponIssue from '../pages/payment/coupon/issue';
import PaymentRetire from '../pages/payment/retire';
import PaymentRetireDetail from '../pages/payment/retire/detail';
import OverallSales from '../pages/payment/overall-sales';
import FinancialsManagement from '../pages/payment/financial/management';
import PaymentRecordNice from '../pages/payment/record-nice';
import NicePaymentRefund from '../pages/payment/refund-nice';
import OverallSalesNice from '../pages/payment/overall-sales-nice';

const PaymentRouter: FC = () => {
  return (
    <Switch>
      <Route path="/payment/record" exact component={PaymentRecord} />
      <Route path="/payment/record-nice" exact component={PaymentRecordNice} />
      <Route path="/payment/charge" exact component={PaymentCharge} />
      <Route path="/payment/refund" exact component={PaymentRefund} />
      <Route path="/payment/refund-nice" exact component={NicePaymentRefund} />
      <Route path="/payment/coupon" exact component={PaymentCoupon} />
      <Route
        path="/payment/coupon/:campusCode/:couponCode/list"
        exact
        component={PaymentCouponList}
      />
      <Route
        path="/payment/coupon/:campusCode/:couponCode/issue"
        exact
        component={PaymentCouponIssue}
      />
      <Route path="/payment/retire" exact component={PaymentRetire} />
      <Route
        path="/payment/retire/:calculateCode/detail"
        exact
        component={PaymentRetireDetail}
      />
      <Route path="/payment/overall-sales" exact component={OverallSales} />
      <Route path="/payment/overall-sales-nice" exact component={OverallSalesNice} />
      <Route path="/payment/financial" exact component={FinancialsManagement} />
    </Switch>
  );
};

export default PaymentRouter;
